<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             :title="(editing ? 'Editar' : 'Crear') + ' Recomendación' "
    >
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="recommendation"
        >
            <b-row>

                <b-col cols="12">
                    <b-form-group>
                        <label for="id_estandar">
                            Estándar
                        </label>
                        <el-select v-model="recommendation.id_estandar"
                                   id="id_estandar"
                                   name="id_estandar"
                                   filterable
                                   size="small"
                                   placeholder="Seleccione un estándar"
                                   class="w-100"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   data-vv-as=" "
                                   v-validate="'required'"
                        >
                            <el-option v-for="standard in standards"
                                       :key="standard.id"
                                       :label="standard.nombre"
                                       :value="standard.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('recommendation.id_estandar')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="id_tipo_recomendacion">
                            Tipo
                        </label>
                        <el-select v-model="recommendation.id_tipo_recomendacion"
                                   id="id_tipo_recomendacion"
                                   name="id_tipo_recomendacion"
                                   filterable
                                   size="small"
                                   placeholder="Seleccione un estándar"
                                   class="w-100"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   data-vv-as=" "
                                   v-validate="'required'"
                        >
                            <el-option v-for="recommendation_type in recommendation_types"
                                       :key="recommendation_type.id"
                                       :label="recommendation_type.descripcion"
                                       :value="recommendation_type.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('recommendation.id_tipo_recomendacion')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="codigo">Código</label>
                        <el-input id="codigo"
                                  name="codigo"
                                  size="small"
                                  v-model="recommendation.codigo"
                                  data-vv-as=" "
                                  v-validate="'required|min:1|max:6'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('recommendation.codigo')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="descripcion">Descripción</label>
                        <el-input id="descripcion"
                                  name="descripcion"
                                  size="small"
                                  type="textarea"
                                  v-model="recommendation.descripcion"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('recommendation.descripcion')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group>
                        <label for="worker_control"
                               class="w-100"
                        >
                            Control trabajador
                        </label>
                        <b-form-radio-group
                            id="worker_control"
                            name="worker_control"
                            buttons
                            :options="[{text: 'SI', value: 1},{text: 'NO', value: 0}]"
                            v-model="recommendation.worker_control"
                            :button-variant="recommendation.worker_control === 0 ? 'outline-secondary' : 'outline-primary'"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group>
                        <label for="company_control"
                               class="w-100"
                        >
                            Control empresa
                        </label>
                        <b-form-radio-group
                            id="company_control"
                            name="company_control"
                            buttons
                            :options="[{text: 'SI', value: 1},{text: 'NO', value: 0}]"
                            v-model="recommendation.company_control"
                            :button-variant="recommendation.company_control === 0 ? 'outline-secondary' : 'outline-primary'"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <div class="w-100 text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateForm()"
                    >
                        <i class="fa fa-save"/> Guardar
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="setShowToModal(false)"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </div>
            </b-row>
        </b-form>


    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('control_sheets', [
            'recommendation_types',
            'recommendation',
            'standards',
            'editing',
            'modal'
        ])
    },
    methods: {
        ...mapActions('control_sheets', [
            'addRecommendation',
            'updateRecommendation'
        ]),
        ...mapMutations('control_sheets', [
            'resetParams',
            'setShowToModal'
        ]),
        validateForm() {
            this.$validator.validateAll('recommendation')
                .then((result) => {
                    if (result) {
                        if (this.editing) {
                            this.updateRecommendation();
                        } else {
                            this.addRecommendation();
                        }
                    }
                });
        }
    },
};
</script>

<style scoped>
</style>
